export default __webpack_public_path__ + "static/media/box_1.dbaee370.jpeg";